import { useState } from 'react';

interface SearchFieldProps {
    value: string;
    onChange: (value: string) => void;
    onSearch: () => void;
    disabled?: boolean;
}

const SearchField: React.FC<SearchFieldProps> = ({ value, onChange, onSearch, disabled }) => {
    return (
        <div className="flex items-center justify-center">
            <input
                type="text"
                value={value}
                onChange={(e) => onChange(e.target.value)}
                placeholder="Describe your intent signal here"
                disabled={disabled}
                className={`flex p-[16px] h-[34px] w-full border text-[14px] font-normal border-[#DDDDDD] rounded-[10px] focus:outline-none focus:ring-1 focus:ring-[#42E56F] text-[#222222] placeholder-[#9FA1A7] placeholder:text-[14px] placeholder:font-normal`}
            />
        </div>
    )
}

export default SearchField;